import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

const when = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;

const Row = ({ u, me }) => {
  const qc = useQueryClient();
  const remove = async () => {
    if (!window.confirm(`Delete ${u.name} (${u.email})?\n\nTheir map, lists, goals, friends and requests are removed for good.`)) return;
    try {
      await api.adminDeleteUser(u.user_id);
      toast.success(`${u.name} deleted`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't delete");
    }
    qc.invalidateQueries({ queryKey: ["admin-users"] });
    qc.invalidateQueries({ queryKey: ["admin-stats"] });
  };
  return (
    <li className="py-4 flex items-center gap-3" data-testid={`admin-user-${u.user_id}`}>
      <div className="w-9 h-9 shrink-0 rounded-full overflow-hidden bg-[#1C2536] grid place-items-center font-display text-sm">
        {u.picture ? <img src={u.picture} alt="" className="w-full h-full object-cover" referrerPolicy="no-referrer" /> : u.name[0]}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm text-slate-100 truncate">{u.name}{u.handle && <span className="text-slate-500 font-mono text-xs"> · /{u.handle}</span>}</p>
        <p className="text-xs text-slate-400 truncate">{u.email}</p>
        <p className="font-mono text-[10px] text-slate-600 mt-0.5">Joined {when(u.created_at)} · been to {u.visited} · wants {u.wanted} · {plural(u.friends, "friend")}</p>
      </div>
      {u.user_id === me ? <span className="text-[11px] text-slate-500">You</span> : (
        <button onClick={remove} data-testid={`admin-user-delete-${u.user_id}`}
          className="shrink-0 flex items-center gap-1 px-3 py-1.5 rounded-full text-xs border border-red-400/40 text-red-300 hover:bg-red-400/10 transition-colors"><Trash2 size={12} /> Delete</button>
      )}
    </li>
  );
};

export const UserList = () => {
  const { user } = useAuth();
  const { data, isLoading } = useQuery({ queryKey: ["admin-users"], queryFn: api.adminUsers });
  if (isLoading) return <p className="mt-8 text-sm text-slate-500">Loading…</p>;
  return (
    <ul className="max-w-3xl mt-4 divide-y divide-white/5 border-y border-white/5" data-testid="admin-user-list">
      {(data || []).map((u) => <Row key={u.user_id} u={u} me={user?.user_id} />)}
    </ul>
  );
};
